import 'swiper/dist/css/swiper.css'
import mediasMixins from 'root/mixins/mediasMixin.js'
import desktopImageMixin from 'root/mixins/desktopImageMixin.js'

export default {
  name: 'main-category-slider',
  mixins: [mediasMixins, desktopImageMixin],
  props: ['data'],
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    mainswiper () {
      return this.$refs.mainSwiper.swiper
    },
    dataParsed: function () {
      return JSON.parse(this.data)
    }
  },

  watch: {
    ismobile: function (val, oldVal) {
      this.mainswiper.init()
      if (val) {
        this.swiper.slideTo(this.slideActive)
      }
    },

    browserMediaQuery: function (mediaQuery) {
      var items = this.desktopSliderImageFallback(this.dataParsed.rotatingComponents, mediaQuery).bannersList
      var timeout = this.desktopSliderImageFallback(this.dataParsed.rotatingComponents, mediaQuery).timeout

      _.each(items, _.bind(function (item) {
        item.title = item.headline[this.$root.locale]
        item.text = item.content[this.$root.locale]

        if(item.videoId)
        {
          const streamUrl = new URL('https://iframe.videodelivery.net/' + item.videoId);
 
          if(item.controls)
            streamUrl.searchParams.append('controls', item.controls);
          if(item.autoplay === "true")
            streamUrl.searchParams.append('autoplay', item.autoplay);
          if(item.loop === "true")
            streamUrl.searchParams.append('loop', item.loop);
          if(item.muted === "true")
            streamUrl.searchParams.append('muted', item.muted);

          item.streamVideoUrl = streamUrl.href;
        }
      }, this))
      this.items = items

      if(timeout > 0)
      {
        this.mainswiper.params.autoplay.delay = timeout * 1000
        // this.mainswiper.params.autoplay.disableOnInteraction = false
        this.mainswiper.autoplay.start()
      }
    }
  },

  data () {
    const vue = this
    return {
      items: [],
      slideActive: 0,
      bottomSlideIndex: 0,
            swiperOption: {
        preloadImages: false,
        slidesPerView: 1,
        spaceBetween: 40,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        }
      }
    }
  },
  methods: {
    clickBullet: function (event) {
      this.mainswiper.slideTo(event.currentTarget.dataset.index)
    }
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/maincategoryslider/maincategoryslider.js